import { useContext } from 'react';

import logJsUnexpected from '@zr/utilities/telemetry/logJsUnexpected';
import { TranslationKey, TranslationsContext } from './TranslationContext';

type translate<TTranslationKey> =
  (key: TTranslationKey, ...args: string[]) => string;

export function useTranslations<TTranslationKey extends TranslationKey>(defaultTranslations?: Record<string, string>):
translate<TTranslationKey> {
  const { translations, prefix } = useContext(TranslationsContext);

  return (key) => {
    const keyStr = key as string;
    const translation = translations[`${prefix}${keyStr}`] || translations[keyStr];
    if (!translation) {
      // eslint-disable-next-line no-console
      console.warn(`Missing translation for ${keyStr}!`);
      logJsUnexpected('missing_translation', { key });
      if (defaultTranslations?.[keyStr]) {
        return defaultTranslations[keyStr];
      }
      return `MISSING TRANSLATION: {${keyStr}}`;
    }
    return translation;
  };
}
export default useTranslations;
